import { HttpService } from '../core/http/http.service';
import { Injectable } from '@angular/core';
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";
import { IIdName } from '../_entities';

@Injectable()
export class IndustryService extends DataAccessServiceBase<IIdName> {

    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return "api/industry";
    }

    getTemplates(): Promise<IIdName[] | any> {
        return this.httpService.get<IIdName[]>(`${this.getControllerUrl()}/templates`)
            .catch(e => {
                this.validationService.handleError(e);
            });
    }

}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/industry.service.ts